import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import AuthActions from "../../redux/auth/actions";
import dealerAction from "../../redux/dealer/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  isAdmin,
  isDealer,
  isAdminAgent,
  allowDealerCreation,
  isAdminOrAgent,
} from "../../helpers/commonFunction";
import Logo from "../../../src/assets/images/USACANADA_LOGO.png";

const BASE_URL = process.env.REACT_APP_BASEURL;

const { getUserDataByToken } = AuthActions;
function Sidebar() {
  const dispatch = useDispatch();
  const { getDealerLevel } = dealerAction;
  const tokenData = useSelector((state) => state.auth.tokenData);
  // const dealerLevelResult = useSelector((state) => state.dealer.dealerLevelResult);
  useEffect(() => {
    dispatch(getUserDataByToken());
    dispatch(getDealerLevel());
  }, [dispatch]);

  const openSampleFileInNewTab = () => {
    const url = `${BASE_URL}/pdf/MVNO.pdf`;
    window.open(url, "_blank");
  };

  return (
    <div className="iq-sidebar">
      <div className="iq-sidebar-logo d-block">
        <a href="/">
          <img src={Logo} alt="Logo" />
        </a>
      </div>
      <div id="sidebar-scrollbar">
        <nav className="iq-sidebar-menu">
          <ul id="iq-sidebar-toggle" className="iq-menu">
            {true && (
              <li className="shouldActive">
                {" "}
                <NavLink to="/" className="iq-waves-effect">
                  <i className="ri-home-4-line"></i>
                  <span>Dashboard</span>
                </NavLink>{" "}
              </li>
            )}

            {(isAdmin(tokenData) || isDealer(tokenData)) && (
              <li>
                <a
                  href="#admin"
                  class="iq-waves-effect collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="ri-admin-line"></i>
                  <span>Admin</span>
                  <i class="ri-arrow-right-s-line iq-arrow-right"></i>
                </a>
                <ul
                  id="admin"
                  class="pl-3 collapse"
                  data-parent="#iq-sidebar-toggle"
                >
                  {isAdmin(tokenData) || allowDealerCreation(tokenData) ? (
                    <li className="shouldActive">
                      <NavLink to="/dealer" className="iq-waves-effect">
                        <i className="ri-shield-user-line"></i>
                        <span>Dealer</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                  {(isAdmin(tokenData) || isDealer(tokenData)) && (
                    <li className="shouldActive">
                      <NavLink to="/user" className="iq-waves-effect">
                        <i className="ri-user-line"></i>
                        <span>User</span>
                      </NavLink>
                    </li>
                  )}
                  {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/t-mobile-dealer" className="iq-waves-effect"><i className="ri-contacts-book-2-line"></i><span>T - Mobile Dealer</span></NavLink></li>} */}
                  {isAdmin(tokenData) && (
                    <li className="shouldActive">
                      <NavLink
                        to="/manual-add-fund"
                        className="iq-waves-effect"
                      >
                        <i className="ri-money-dollar-circle-line"></i>
                        <span>Manual Add Fund</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(isAdmin(tokenData) ||
              isDealer(tokenData) ||
              isAdminAgent(tokenData)) && (
              <li>
                <a
                  href="#config"
                  class="iq-waves-effect collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="ri-list-settings-line"></i>
                  <span>Config</span>
                  <i class="ri-arrow-right-s-line iq-arrow-right"></i>
                </a>
                <ul
                  id="config"
                  class="pl-3 collapse"
                  data-parent="#iq-sidebar-toggle"
                >
                  {isAdmin(tokenData) && (
                    <li className="shouldActive">
                      <NavLink to="/network">
                        <i className="ri-ie-line"></i>Network
                      </NavLink>
                    </li>
                  )}
                  {/* {isAdmin(tokenData) && (
                      <li className="shouldActive">
                        <NavLink to="/aggregator">
                          <i className="ri-user-2-line"></i>Aggregator
                        </NavLink>
                      </li>
                    )} */}
                  {(isAdmin(tokenData) || isDealer(tokenData)) && (
                    <li className="shouldActive">
                      <NavLink to="/plan">
                        <i className="ri-building-2-line"></i>Plan
                      </NavLink>
                    </li>
                  )}
                  {/* {isAdmin(tokenData) && (
                    <li className="shouldActive">
                      <NavLink to="/recharge-plan">
                        <i className="ri-building-4-line"></i>Recharge Plan
                      </NavLink>
                    </li>
                  )} */}

                  {/* {(isAdmin(tokenData) || isDealer(tokenData)) && <li className='shouldActive'><NavLink to="/addon-service"><i className="ri-building-3-line"></i>Addon Service</NavLink></li>} */}
                  {isAdmin(tokenData) && (
                    <li className="shouldActive">
                      <NavLink to="/plan-price-mapping">
                        <i className="ri-price-tag-2-line"></i>Plan Price
                        Mapping
                      </NavLink>
                    </li>
                  )}
                  {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/addon-price-mapping"><i className="ri-china-railway-line"></i>Addon Price Mapping</NavLink></li>} */}
                  {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/asset"><i className="ri-checkbox-blank-line"></i>Asset</NavLink></li>} */}
                  {/* {(isAdmin(tokenData) || isAdminAgent(tokenData)) && <li className='shouldActive'><NavLink to="/upload-jar"><i className="ri-chrome-fill"></i>JAR Download</NavLink></li>} */}
                  {/* {allowDealerCreation(tokenData) && (
                    <li className="shouldActive">
                      <NavLink to="/dealer-plan-price-mapping">
                        <i className="ri-price-tag-2-line"></i>Plan Price
                        Mapping
                      </NavLink>
                    </li>
                  )} */}
                  {/* {(allowDealerCreation(tokenData)) && <li className='shouldActive'><NavLink to="/dealer-addon-price-mapping"><i className="ri-china-railway-line"></i>Addon Price Mapping</NavLink></li>} */}
                  {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/daily-addon-price-mapping"><i className="ri-china-railway-line"></i>Daily Addon Price Mapping</NavLink></li>} */}
                  {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/api-key"><i className="ri-door-lock-line"></i>API Keys</NavLink></li>} */}
                </ul>
              </li>
            )}

            {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
              <li>
                <a
                  href="#inventory"
                  class="iq-waves-effect collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="ri-archive-line"></i>
                  <span>Inventory</span>
                  <i class="ri-arrow-right-s-line iq-arrow-right"></i>
                </a>
                <ul
                  id="inventory"
                  class="pl-3 collapse"
                  data-parent="#iq-sidebar-toggle"
                >
                  {isAdmin(tokenData) && (
                    <li className="shouldActive">
                      <NavLink
                        to="/sim-pin-inventory"
                        className="iq-waves-effect"
                      >
                        <i className="ri-archive-line"></i>
                        <span>SIM PIN Inventory</span>
                      </NavLink>
                    </li>
                  )}
                  {/* {((isAdmin(tokenData)) || isAdminAgent(tokenData)) && <li className='shouldActive'><NavLink to="/portin-sim-list" className="iq-waves-effect"><i className="ri-sim-card-2-line"></i><span>Portin SIM List</span></NavLink></li>}
                                {(isAdminOrAgent(tokenData)) && <li className='shouldActive'><NavLink to="/msisdn-pool"><i className="ri-sim-card-line"></i>MSISDN Pool</NavLink></li>} */}
                </ul>
              </li>
            )}

            <li>
              <a href="" className="iq-waves-effect">
                <i class="ri-building-3-line"></i>
                <span>Activations</span>
              </a>
            </li>
            <div className="pl-3 fs-14">
              {/* {true && (
                <li className="shouldActive">
                  <NavLink to="/activation-request">
                    <i className="ri-font-color"></i>Activation Request
                  </NavLink>
                </li>
              )} */}

              {true && (
                <li className="shouldActive">
                  <NavLink to="/chatr-activation">
                    <i className="ri-font-color"></i>Chatr Activation
                  </NavLink>
                </li>
              )}
              {/* {((isAdmin(tokenData)) || isAdminAgent(tokenData)) && <li className='shouldActive'><NavLink to="/repush-activation"><i class="ri-restart-line"></i>Repush Activation</NavLink></li>} */}
              {/* {true && (
                <li className="shouldActive">
                  <NavLink to="/portin-activation">
                    <i class="ri-sim-card-2-line"></i>Portin Activation
                  </NavLink>
                </li>
              )} */}
              {/* {true && (
                <li className="shouldActive">
                  <NavLink to="/recharge-request">
                    <i className="ri-battery-2-charge-line"></i>Recharge Request
                  </NavLink>
                </li>
              )} */}
              {true && (
                <li className="shouldActive">
                  <NavLink to="/activation-status">
                    <i className="ri-sim-card-line"></i>Activation Status
                  </NavLink>
                </li>
              )}

              {true && (
                <li className="shouldActive">
                  <NavLink to="/mdn-swap">
                    <i className="ri-swap-line"></i>MDN Swap
                  </NavLink>
                </li>
              )}

              {/* {<li className='shouldActive'><NavLink to="/sim-swap-request"><i className="ri-sim-card-2-line"></i>SIM Swap Request</NavLink></li>} */}
              {/* {<li className='shouldActive'><NavLink to="/daily-acts-plan"><i className="ri-sim-card-2-line"></i>Daily Acts Plan</NavLink></li>} */}
              {/* {((isAdmin(tokenData)) || isAdminAgent(tokenData)) && <li className='shouldActive'><NavLink to="/locked-activation" className="iq-waves-effect"><i className="ri-lock-line"></i><span>Locked Activation</span></NavLink></li>} */}
              {/* {<li className='shouldActive'><NavLink to="/email-inbox"><i class="ri-mail-line"></i>E-Mail Inbox</NavLink></li>} */}
              {/* {<li className='shouldActive'><NavLink to="/outside-email-inbox"><i class="ri-mail-line"></i>Outside E-Mail Inbox</NavLink></li>} */}
            </div>
            <li>
              <a
                href="#report"
                class="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="false"
              >
                <i class="ri-file-chart-line"></i>
                <span>Reports</span>
                <i class="ri-arrow-right-s-line iq-arrow-right"></i>
              </a>
              <ul
                id="report"
                class="pl-3  collapse"
                data-parent="#iq-sidebar-toggle"
              >
                {true && (
                  <li className="shouldActive">
                    <NavLink to="/chatr-activation-report">
                      <i className="ri-file-chart-line"></i>Chatr Activation
                      Report
                    </NavLink>
                  </li>
                )}

                {true && (
                  <li className="shouldActive">
                    <NavLink to="/mdn-swap-report">
                      <i className="ri-file-chart-line"></i>MDN Swap Report
                    </NavLink>
                  </li>
                )}
                {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/asset-performance-report"><i className="ri-font-color"></i>Asset Performance Report</NavLink></li>} */}
                {/* {(isAdmin(tokenData) || isDealer(tokenData)) && (
                  <li className="shouldActive">
                    <NavLink to="/audit-report">
                      <i className="ri-folder-chart-line"></i>Audit Report
                    </NavLink>
                  </li>
                )} */}
                {/* {(isAdmin(tokenData)) && <li className='shouldActive'><NavLink to="/manual-activation-report"><i className="ri-file-info-line"></i>Manual Activation Report</NavLink></li>} */}
                {/* {true && <li className='shouldActive'><NavLink to="/bulk-activation-report"><i className="ri-file-chart-line"></i>Bulk Activation Report</NavLink></li>} */}
                {/* {<li className='shouldActive'><NavLink to="/daily-plan-request-report"><i className="ri-sim-card-2-line"></i>Daily Plan Request Report</NavLink></li>} */}
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      {/* <div className="iq-sidebar-logo d-flex justify-content-between help-button">
                {true && <button className='shouldActive help-btn-h'
                ><a href="#" className="iq-waves-effect" onClick={(e) => { e.preventDefault(); openSampleFileInNewTab(); }} ><i className="ri-question-line"></i><span >
                    Help</span> </a> </button>}
            </div> */}
    </div>
  );
}

export default Sidebar;
